<template>
  <div class="score-entry-student">
    <div class="btn-list">
      <span style="margin-right: 5px; font-weight: bold">学生姓名</span>
      <el-select v-model="selectStudent" filterable placeholder="请选择学生" @change="studentChange">
        <el-option v-for="(item, index) in gradeStudentList" :key="index" :label="item.studentName" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <el-table :data="activityFullList" border style="width: 600px; margin: 0 auto; max-height: 300px; overflow-y: auto">
      <!-- <el-table-column label="实践活动" prop="activityName"></el-table-column> -->
      <el-table-column label="实践活动">
        <template slot-scope="scope">
          <el-input v-model="activityData.activityName" disabled></el-input>
        </template>
      </el-table-column>
      <el-table-column label="学时">
        <template slot-scope="scope">
          <el-input v-model="scope.row.hours"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="学分">
        <template slot-scope="scope">
          <el-input v-model="scope.row.credit"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="评定等级">
        <template slot-scope="scope">
          <el-input v-model="scope.row.evaluationLevel"></el-input>
        </template>
      </el-table-column>
    </el-table>
    <div class="btn-list">
      <el-button type="primary" plain @click="back">返回</el-button>
      <el-button type="primary" @click="scoreEntryStudentSubmit">确认</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["isChooseContainerShow", "gradeStudentList", "activityData"],
  data() {
    return {
      activityFullList: [
        {
          activityName: "篮球比赛",
          hours: "", // 学时
          credit: "", // 学分
          evaluationLevel: "", // 评定等级
        },
      ],
      selectStudent: "",
    };
  },
  methods: {
    studentChange(e) {
      // console.log("选中的学生==>", this.selectStudent, this.activityData);
      let { schoolYear, semester, activityName } = this.activityData;
      let data = {
        studentId: e,
        schoolYear,
        semester,
        activityName
      };
      this.post(this.$url.getPracticeRecordList, data).then(res => {
        // console.log(res);
        this.activityFullList = res.data.length ? res.data : [
          {
            activityName: "篮球比赛",
            hours: "", // 学时
            credit: "", // 学分
            evaluationLevel: "", // 评定等级
          },
        ];
      })
    },
    // 单个学生录入成绩点击提交
    scoreEntryStudentSubmit() {
      if (this.selectStudent == "") return this.$message.warning("请选择学生");
      let data = {
        studentId: this.selectStudent,
        schoolYear: this.activityData.schoolYear,
        semester: this.activityData.semester,
        activityId: this.activityData.id,
        credit: this.activityFullList[0].credit,
        hours: this.activityFullList[0].hours,
        evaluationLevel: this.activityFullList[0].evaluationLevel,
      };
      // console.log("单个学生录入成绩点击提交:", data);
      this.$emit("scoreEntryStudentSubmit", data);
    },
    // 返回选择录入方式
    back() {
      this.$emit("update:isChooseContainerShow", true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./scoreEntryStudent.scss";
</style>